import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, InputAdornment, Typography, TextField } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
// components
import axios from 'axios';
import Iconify from '../../../components/iconify';
import { getToken, setUserSession, getRefreshToken, getAcl } from '../../../utils/common';
import { get } from 'lodash';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const history = useNavigate();
  const mail = useFormInput('');
  const password = useFormInput('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accesstoken, setaccesstoken] = useState('');
  const [refreshtoken, setrefreshtoken] = useState('');
  const [open, setopen] = useState(false);
  const navconficCustom = [];
  const navConfig = [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      namaroute: 'dashboard',
    },
    {
      title: 'users',
      path: '/dashboard/user',
      namaroute: 'user',
    },
    {
      title: 'actions',
      path: '/dashboard/action',
      namaroute: 'action',
    },
    {
      title: 'alerts',
      path: '/dashboard/alert',
      namaroute: 'alert',
    },
    {
      title: 'reports',
      path: '/dashboard/report',
      namaroute: 'report',
    },
    {
      title: 'bulletins',
      path: '/dashboard/blog',
      namaroute: 'bulletin',
    },
    {
      title: 'information',
      path: '/dashboard/information',
      namaroute: 'information',
    },
    {
      title: 'Dataset Map',
      path: '/dashboard/dataset',
      namaroute: 'data_set',
    },
    {
      title: 'About',
      path: '/dashboard/about',
      namaroute: 'about',
    },
    {
      title: 'Activity Log',
      path: '/dashboard/activitylogs',
      namaroute: 'activity',
    },
    {
      title: 'logout',
      path: '/login',
      namaroute: 'logout',
    },
  ];

  useEffect(() => {
    if (getToken() != null && getRefreshToken() != null) {
      history('/dashboard/app');
    }
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      // Perform your login action here
      handleLogin();
    }
  };

  const handleLogin = async () => {
    setError(null);
    setLoading(true);

    try {
      const response = await axios.post(
        window.REACT_APP_API_PURE + 'login',
        {
          username: mail.value,
          password: password.value,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      setLoading(false);
      setUserSession(
        response.data.access_token,
        mail.value,
        response.data.role,
        response.data.full_name,
        response.data.refresh_token
      );

      if (response.data.reset_password === true) {
        setrefreshtoken(response.data.refresh_token);
        setaccesstoken(response.data.access_token);
        setopen(true);
      } else {
        let acl = getAcl(); // Initial attempt to get ACL data
        let maxRetries = 10; // Maximum number of retries to avoid infinite loops
        let attempts = 0;

        // Loop until acl is filled or max retries is reached
        while ((!acl || acl.length === 0) && attempts < maxRetries) {
          attempts += 1;

          // Optional: Add a small delay between retries to avoid rapid looping
          await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 second delay
          acl = getAcl(); // Try to get ACL data again
        }

        if (!acl || acl.length === 0) {
          // Handle this scenario as needed
          console.error('Failed to retrieve ACL data after multiple attempts');
        }

        // Convert ACL to JSON
        const aclJson = JSON.parse(acl);

        navConfig.forEach((c) => {
          const menu = aclJson?.find((e) => c.namaroute === e.nama_menu && e.read === true);
          if (menu !== undefined || c.namaroute === 'logout') {
            navconficCustom.push(c);
          }
        });

        history(navconficCustom[0]?.path);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error during login process:', error);

      // More specific error handling
      if (error.message.includes('Failed to retrieve ACL data')) {
        console.error('ACL data retrieval failed after multiple attempts.');
      } else if (error.response && error.response.status === 401) {
        setError(error.response.data.message);
      } else {
        setError('Email or Password is incorrect, Please contact Administrator');
      }
    }
  };

  return (
    <div className="flex flex-col w-full max-w-sm items-center space-y-5">
      {error ? (
        <div className="bg-red-100 border border-red-500 text-red-500 w-full py-4 px-6 flex flex-row items-center space-x-5 rounded-md justify-center">
          <span>
            <Iconify icon="eva:close-circle-fill" />
          </span>
          <span className="text-sm">{error}</span>
        </div>
      ) : null}
      <div className="w-full">
        <div className="text-sm text-gray-500">Email</div>
        <TextField
          type="text"
          id="username"
          size="small"
          fullWidth
          name="email"
          required
          onChange={mail.onChange}
          value={mail.value}
          placeholder="Email"
        />
      </div>
      <div className="w-full relative">
        <div className="text-sm text-gray-500">Password</div>
        <TextField
          name="password"
          id="password"
          fullWidth
          size="small"
          type={showPassword ? 'text' : 'password'}
          required
          onChange={password.onChange}
          value={password.value}
          placeholder="password"
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="button" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <button
        disabled={loading || mail.value === '' || password.value === ''}
        onClick={handleLogin}
        type="button"
        className="bg-blue-button text-white w-full py-2 px-4 rounded-md disable:bg-blue-300"
      >
        {loading ? 'Loading...' : 'Login'}
      </button>
    </div>
  );
}
const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
